<div>
  <kl-add-page-task-members
    [projectId]="projectId"
    [taskId]="taskId"
    [pageId]="pageId"></kl-add-page-task-members>
</div>
